import React from 'react';
import {Box} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import BuildIcon from '@mui/icons-material/Build';
import CloseIcon from '@mui/icons-material/Close';
import {TEXTE, VERDICT_COULEURS, VERDICT_LIBELLES} from '../tokens.js';

const GLYPHES = {ras: CheckIcon, pb: BuildIcon, imp: CloseIcon, ni: null};

/** Pastille de verdict (20 px, glyphe blanc ; « non inspecté » = contour pointillé) + libellé. */
export default function PiluleVerdict({verdict, libelle, taille = 20}) {
    const couleurs = VERDICT_COULEURS[verdict] || VERDICT_COULEURS.ni;
    const Glyphe = GLYPHES[verdict] || null;
    const pointille = !Glyphe;
    return (
        <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: '8px', color: TEXTE, fontWeight: 600, fontSize: 13}}>
            <Box
                component="span"
                aria-hidden="true"
                sx={{
                    width: taille, height: taille, borderRadius: '50%', flex: 'none', boxSizing: 'border-box',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    backgroundColor: pointille ? '#FFFFFF' : couleurs.pastille,
                    border: pointille ? `2px dotted ${couleurs.pastille}` : 'none',
                    color: '#FFFFFF',
                }}
            >
                {Glyphe && <Glyphe sx={{fontSize: Math.round(taille * 0.65)}}/>}
            </Box>
            <Box component="span" sx={{color: couleurs.texte}}>{libelle || VERDICT_LIBELLES[verdict]}</Box>
        </Box>
    );
}
